import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { FilterLicenses as FilterLicensesReducer } from '../../reducers/r_index';

//Components
import GridLicenzeCmp from '../../components/gestione_licenze/GridLicenzeCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
    detailContainer: {
        margin: '10px',
    },
});

class GridLicenze extends Component {

    componentDidMount() {
        if (this.props.codiceUtente !== 'anonymous')
            this.props.getLicenses(this.props.codiceUtente);
    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.codiceUtente !== propsPrecedenti.codiceUtente) {
            if (this.props.codiceUtente !== 'anonymous')
                this.props.getLicenses(this.props.codiceUtente);
        }
    }

    render() {
        const { ...props } = this.props;

        return (
            <GridLicenzeCmp {...props} />
        );

    }
}

GridLicenze.propTypes = {
    getLicenses: PropTypes.func.isRequired,
    lista_licenze: PropTypes.arrayOf(PropTypes.object).isRequired,
    getLicensesRequestStatus: PropTypes.string.isRequired,

    selection: PropTypes.arrayOf(PropTypes.number).isRequired,
    selectedRowIndex: PropTypes.number.isRequired,
    // selected_license:  PropTypes.shape({}).isRequired,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    sorting: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
    expandedRowIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    columnWidths: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hiddenColumnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    
    onSortingChange: PropTypes.func.isRequired,
    onFiltersChange: PropTypes.func.isRequired,
    onCurrentPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onColumnWidthsChange: PropTypes.func.isRequired,
    handleRowSelection: PropTypes.func.isRequired,

    setSelectedLicense: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};


const mapDispatchToProps = dispatch => ({
    getLicenses: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },

    onSortingChange: (sorting) => { dispatch(FilterLicensesReducer.creators.onGridAction('sorting', sorting)) },
    onFiltersChange: (filters) => { dispatch(FilterLicensesReducer.creators.onGridAction('filters', filters)) },
    onCurrentPageChange: (currentPage) => { dispatch(FilterLicensesReducer.creators.onGridAction('currentPage', currentPage)) },
    onPageSizeChange: (pageSize) => { dispatch(FilterLicensesReducer.creators.onGridAction('pageSize', pageSize)) },
    onColumnWidthsChange: (widths) => { dispatch(FilterLicensesReducer.creators.onGridAction('columnWidths', widths)) },
    OnHiddenColumnChange: (columnNames) => { dispatch(FilterLicensesReducer.creators.onGridAction('hiddenColumnNames', columnNames)) },
    handleRowSelection: (newSelection) => { dispatch(FilterLicensesReducer.creators.handleRowSelection(newSelection)) },
    setSelectedLicense: (selected_license) => { dispatch(FilterLicensesReducer.creators.setSelectedLicense(selected_license)) },
    handleExpandedRow: (newExpandedRowIds) => { dispatch(FilterLicensesReducer.creators.handleExpandedRow(newExpandedRowIds)) },
    
    resetFilters: () => { dispatch(FilterLicensesReducer.creators.resetFilters()) },
});

const mapStateToProps = state => ({
    lista_licenze: state['licenze'].lista_licenze,
    getLicensesRequestStatus: state['licenze'].status,


    selection: state['filtro-licenze'].selection,
    selectedRowIndex: state['filtro-licenze'].selectedRowIndex,
    // selected_license: state['filtro-licenze'].selected_license,
    filters: state['filtro-licenze'].filters,
    sorting: state['filtro-licenze'].sorting,
    currentPage: state['filtro-licenze'].currentPage,
    pageSize: state['filtro-licenze'].pageSize,
    pageSizes: state['filtro-licenze'].pageSizes,
    expandedRowIds: state['filtro-licenze'].expandedRowIds,
    columnWidths: state['filtro-licenze'].columnWidths,
    hiddenColumnNames: state['filtro-licenze'].hiddenColumnNames,

    codiceUtente: state['logged-user'].codiceUtente,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GridLicenze));